import { Component, OnInit, OnDestroy } from "@angular/core";
import { MenuController } from "@ionic/angular";
import { FormGroup, FormControl, Validators } from "@angular/forms";
import { AuthService } from "../auth.service";
import { ActivatedRoute } from "@angular/router";
import { removeInitScreen } from "src/app/_helpers/appLoading";

@Component({
  selector: "app-reset-password",
  templateUrl: "./reset-password.page.html",
  styleUrls: [
    "./reset-password.page.scss",
    "./../../../_styles/ion-grid-box.scss",
  ],
})
export class ResetPasswordPage implements OnInit {
  form: FormGroup;
  sended = false;
  passwordMatchError = false;
  validationError = false;
  key: string;

  keyValid = false;

  passwordEye = false;
  passwordConfirmEye = false;

  constructor(
    private menu: MenuController,
    private authService: AuthService,
    private route: ActivatedRoute
  ) {
    this.form = new FormGroup(
      {
        password: new FormControl("", {
          updateOn: "blur",
          validators: [
            Validators.required,
            Validators.minLength(8),
            Validators.maxLength(30),
          ],
        }),
        rePassword: new FormControl("", {
          updateOn: "blur",
          validators: [
            Validators.required,
            Validators.minLength(8),
            Validators.maxLength(30),
          ],
        }),
      },
      { updateOn: "change", validators: [this.checkPasswords] }
    );
  }

  ngOnInit() {
    this.menu.enable(false);

    this.route.paramMap.subscribe((paramMap) => {
      this.key = paramMap.get("key");

      //Check if key is valid
      this.authService.checkResetPassword(this.key).subscribe(
        (res) => {
          this.keyValid = true;
        },
        (error) => {}
      );
    });

    removeInitScreen();
  }

  ionViewWillEnter() {
    setTimeout(() => {
      this.menu.enable(false);
    }, 20);
  }

  save() {
    let password = this.form.controls.password.value;
    let rePassword = this.form.controls.rePassword.value;

    if (this.form.invalid) {
      this.validationError = true;

      if (password !== rePassword) {
        this.passwordMatchError = true;
      }

      return;
    }

    //TODO send request
    this.authService.resetPassword(password, this.key).subscribe(
      (res) => {
        this.sended = true;
      },
      (error) => {
        this.sended = false;
      }
    );
  }

  checkPasswords(group: FormGroup) {
    let pass = group.value.password;
    let confirmPass = group.value.rePassword;

    return pass === confirmPass ? null : { notSame: true };
  }

  passwordEyeAction() {
    this.passwordEye = !this.passwordEye;
  }

  passwordConfirmEyeAction() {
    this.passwordConfirmEye = !this.passwordConfirmEye;
  }
}
